var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.activeName,
            callback: function($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName"
          }
        },
        [
          _vm.isAdmin
            ? _c("el-tab-pane", { attrs: { label: "客户资源", name: "first" } })
            : _vm._e(),
          _vm.isAdmin
            ? _c("el-tab-pane", {
                attrs: { label: "分配情况", name: "second" }
              })
            : _vm._e(),
          _vm.isStaff
            ? _c("el-tab-pane", { attrs: { label: "我的任务", name: "third" } })
            : _vm._e()
        ],
        1
      ),
      _vm.activeName === "first" && _vm.isAdmin
        ? _c("CustomerResources")
        : _vm._e(),
      _vm.activeName === "second" && _vm.isAdmin
        ? _c("AllocationSituation")
        : _vm._e(),
      _vm.activeName === "third" && _vm.isStaff ? _c("MyTasks") : _vm._e(),
      !_vm.isAdmin && !_vm.isStaff
        ? _c("el-empty", {
            attrs: {
              "image-size": 400,
              description: "您暂无权限查看，请联系管理员增加权限"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }